import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/tracking";

const DEFAULT_SITE_CONTENT = {
  brand: {
    name: "Ranger Construction",
    tagline: "A Leading Florida Road Building & Asphalt Producing Contractor",
  },
  contact: {
    general_email: "info@rangerconstruction.com",
    estimating_email: "estimating@rangerconstruction.com",
    hq_phone: "561.793.9400",
    hq_address: "1645 N. Congress Ave., West Palm Beach, FL 33409",
  },
  social_links: {},
  latest: {},
  pages: {},
  projects: [],
  news: [],
};

let cached = null;

export function useSiteContent() {
  const [content, setContent] = useState(cached || DEFAULT_SITE_CONTENT);

  useEffect(() => {
    let alive = true;
    axios
      .get(`${API}/site-content`)
      .then(({ data }) => {
        cached = { ...DEFAULT_SITE_CONTENT, ...(data || {}) };
        if (alive) setContent(cached);
      })
      .catch(() => {
        if (alive) setContent(cached || DEFAULT_SITE_CONTENT);
      });
    return () => {
      alive = false;
    };
  }, []);

  return content;
}

export function phoneHref(phone = "") {
  const digits = phone.replace(/[^0-9+]/g, "");
  return digits ? `tel:${digits}` : "#";
}
